<div class="skl-card" aria-busy="true" aria-label="Loading CMDB sync history">
  <div class="skl-card__body">
    <app-skeleton width="110px" height="18px" borderRadius="4px" marginBottom="18px"></app-skeleton>

    <div class="skl-table-wrap">
      <div class="table-responsive">
        <table class="skl-table">
          <colgroup>
            <col style="width: 14%">
            <col style="width: 14%">
            <col style="width: 13%">
            <col style="width: 27%">
            <col style="width: 18%">
            <col style="width: 14%">
          </colgroup>
          <thead>
            <tr>
              @for (col of tableCols; track col) {
                <th>
                  <app-skeleton [width]="col === 3 ? '44%' : col === 4 ? '66%' : col === 5 ? '48%' : col === 6 ? '40%' : '70%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of tableRows; track row) {
              <tr>
                <td><app-skeleton [width]="row % 2 === 0 ? '74%' : '66%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton></td>
                <td><app-skeleton [width]="row % 2 === 0 ? '74%' : '68%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton></td>
                <td>
                  @if (row === 1) {
                    <div class="skl-inline-status">
                      <app-skeleton width="24px" height="24px" borderRadius="12px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="88px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    </div>
                  } @else {
                    <app-skeleton [width]="row % 2 === 0 ? '58%' : '46%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  }
                </td>
                <td class="skl-cell--top">
                  <div class="skl-records-stack">
                    <div class="skl-records-badges">
                      <app-skeleton width="74px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="74px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="70px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                    </div>
                    <div class="skl-records-badges skl-records-badges--secondary">
                      <app-skeleton width="70px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="70px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                    </div>
                    @if (row % 2 === 0) {
                      <app-skeleton width="84%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    }
                  </div>
                </td>
                <td>
                  @if (row % 3 === 0) {
                    <app-skeleton width="118px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton>
                  } @else {
                    <div class="skl-inline-status">
                      <app-skeleton width="62px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="88px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    </div>
                  }
                </td>
                <td>
                  <app-skeleton width="84px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="skl-pagination">
      <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
      <div class="skl-pagination-buttons">
        @for (btn of [1, 2, 3, 4]; track btn) {
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        }
      </div>
    </div>
  </div>
</div>